export default "__VITE_ASSET__D8p4vniO__"